import React, { memo } from 'react';
import { Helmet } from 'react-helmet-async';
import { Switch, Route } from 'react-router-dom';

import { NotFoundPage } from '../../components/NotFoundPage/Loadable';
import HGKOListPage from './components/HGKOListPage';
import HGKOUploadPage from './components/HGKOUploadPage';

interface Props {}

export const HCCodePage = memo((props: Props) => {
  return (
    <>
      <Helmet>
        <title>HC Code Page - JPOA</title>
        <meta name="description" content="" />
      </Helmet>
      <Switch>
        <Route exact path="/hc-code" component={HGKOListPage} />
        <Route exact path="/hc-code/upload" component={HGKOUploadPage} />
        <Route component={NotFoundPage} />
      </Switch>
    </>
  );
});
